import { forwardRef } from 'react';
import ReactQuill from 'react-quill';

const FormDescription = forwardRef(({ value, onChange }, ref) => {
  return (
    <div className="form__description">
      <ReactQuill ref={ref} className="description__editor" value={value} onChange={onChange} theme={null} placeholder="Escreva uma descrição" />
      <label>Descrição</label>
    </div>
  );
});

export default FormDescription;
